import { LocalStorageKey } from "@/app/vars/Storage";

type StoredCollapse = Record<string, boolean>;

export class UScriptSuggestions {
  public static isCollapsed(blockType: string): boolean {
    return UScriptSuggestions.readAll()[blockType] ?? false;
  }

  public static setCollapsed(blockType: string, isCollapsed: boolean): void {
    UScriptSuggestions.write({ ...UScriptSuggestions.readAll(), [blockType]: isCollapsed });
  }

  private static readAll(): StoredCollapse {
    if (typeof window === "undefined") {
      return {};
    }

    try {
      const raw = window.localStorage.getItem(LocalStorageKey.SCRIPT_SUGGESTIONS_COLLAPSED);

      return raw ? (JSON.parse(raw) as StoredCollapse) : {};
    } catch {
      return {};
    }
  }

  private static write(collapse: StoredCollapse): void {
    if (typeof window === "undefined") {
      return;
    }

    window.localStorage.setItem(
      LocalStorageKey.SCRIPT_SUGGESTIONS_COLLAPSED,
      JSON.stringify(collapse),
    );
  }
}
